module.exports = __webpack_public_path__ + "static/media/moderna_cisnedeoro.adc2c5cc.png";